import React from "react";
import { CheckCircle2, ShieldCheck } from "lucide-react";

const CRITERIA = [
  "Gyldig rekreasjonshockey-lisens hos NIHF for lagets klubb",
  "Har ikke spilt i høyere divisjoner enn Old Boys (OB)",
  "Er over 16 år",
];

export default function ApprovalCriteria() {
  return (
    <div className="swiss-card p-5 mb-6 bg-neutral-50" data-testid="approval-criteria">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-black text-white flex items-center justify-center shrink-0">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-1">Godkjenningskriterier</div>
          <div className="font-heading text-lg font-black uppercase tracking-tight mb-3">Spilleren må oppfylle alle 3 punkter</div>
          <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-sm">
            {CRITERIA.map((c) => (
              <li key={c} className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />
                <span><strong className="font-mono text-xs text-neutral-500 mr-1">{CRITERIA.indexOf(c) + 1}.</strong>{c}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}

export function calcAge(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
  return age;
}
